export default "__VITE_ASSET__Bu58e7B6__"